import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import ServiceComparison from '../components/ServiceComparison';
import Customers from '../components/Customers';
import Projects from '../components/Projects';
import WhyMe from '../components/WhyMe';
import Testimonials from '../components/Testimonials';
import Experience from '../components/Experience';
import TargetAudience from '../components/TargetAudience';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';

function Home() {
  return (
    <>
      <Hero />
      <Testimonials />
      <About />
      <Services />
      <ServiceComparison />
      <Customers />
      <Projects />
      <WhyMe />
      <Experience />
      <TargetAudience />
      <FAQ />
      <Contact />
    </>
  );
}

export default Home;